import createInstance from "./createInstance.js";
import togglePlaceholder from "./togglePlaceholder.js";
import removeHtmlComments from "../utilities/removeHtmlComments.js";
import focus from "./focus.js";

const init = async (element, options) => {
    if (!element) return;

    options = options || {};
    element.dataset.theme = options.theme || element.dataset.theme || 'readonly';
    element.dataset.placeholder = options.placeholder || element.dataset.placeholder || '';
    element.dataset.autofocus = `${options.autofocus || element.dataset.autofocus || false}`;

    const quill = element.querySelector('.ra-quill');
    quill.innerHTML = removeHtmlComments(quill.innerHTML);

    element.removeEventListener('focus', focus);

    if (element.dataset.theme === 'bubble') {
        element.tabIndex = 0;
        element.className = '-m-1 border-none focus:outline-none leading-5 p-1 rounded-lg duration-200 hover:bg-black/[.1] transition-colors relative z-10 grow';
        element.setAttribute("contenteditable", true);
        element.addEventListener('focus', focus);
        togglePlaceholder(element);
    }

    if (element.dataset.theme === 'snow') {
        element.tabIndex = 0;
        element.className = '';
        element.setAttribute("contenteditable", false);
        await createInstance(element);
    }

    if (element.dataset.theme === 'readonly') {
        element.tabIndex = -1;
        element.className = 'focus:outline-none leading-5';
        element.setAttribute("contenteditable", false);
        togglePlaceholder(element);
    }
};

export default init;